import React, { useMemo } from 'react'
import axios from 'axios'
import style from './style.module.css'

function ErrorFallback({ error }: { error: unknown }) {
  const message = useMemo(() => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status
      const data = error.response?.data as { error?: unknown }
      if (status === 404) {
        if (typeof data.error === 'string') {
          return data.error
        }
      }
    }

    return 'we are looking into it.'
  }, [error])

  return (
    <div className={style.wrapper}>
      <h2 className='large mb-4'>Something went wrong</h2>
      <p>{message}</p>
    </div>
  )
}

export default ErrorFallback
